var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoVoucherHarmonyIcon = function SvgNoVoucherHarmonyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.874 5.127a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
    fill: "#151414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.274 3.126a1.6 1.6 0 0 1 1.6 1.6v3.341c0 .434-.173.833-.47 1.13l-5.21 5.21a1.6 1.6 0 0 1-2.26 0l-3.34-3.34a1.602 1.602 0 0 1 0-2.26l5.21-5.21c.3-.3.71-.471 1.13-.471h3.34Zm-3.34 1.501c-.02 0-.05.01-.07.03l-5.21 5.21a.102.102 0 0 0 0 .14l3.34 3.34a.101.101 0 0 0 .14 0l5.21-5.21a.114.114 0 0 0 .024-.034.093.093 0 0 0 .006-.036v-3.34a.1.1 0 0 0-.1-.1h-3.34Z",
    fill: "#151414"
  })));
};
export default SvgNoVoucherHarmonyIcon;